import React from 'react';
import { ICONIFY } from '../../../../../Constants/iconify';
import CommonNode from '../../shared/CommonNode';
import NodeWrapper from '../../shared/NodeWrapper';

function CalendarNode({ data }) {
    return (
        <NodeWrapper nodeId={data?.id}>
            <CommonNode data={data} icon={ICONIFY.CALENDAR} />
        </NodeWrapper>
    );
}

export default React.memo(CalendarNode)
